import React, { useEffect } from "react";
import * as subscriptionService from "../../actions/subscription.actions";
import { useSubscription } from "../../context/SubscriptionContext";
import SubscriptionItem from "./SubscriptionItem";
import { useApiResponse } from "../../context/ApiResponseContext";
import Alert from "../../layout/Alert";
import Loading from "../../layout/Loading";

export default function AvailableSubscriptionPlans() {
  const [choiceOfSubscriptions, setChoiceOfSubscriptions] = useSubscription();

  const [apiResponse] = useApiResponse();

  useEffect(() => {
    async function getPlans() {
      const plans = await subscriptionService.getAvailablePlans();

      if (plans && plans.data.success) {
        setChoiceOfSubscriptions(
          ...choiceOfSubscriptions,
          plans.data.activeSubscriptionsDetails
        );
      }
    }

    getPlans();
  }, []);

  return (
    <div>
      {choiceOfSubscriptions && choiceOfSubscriptions.length === 0 ? (
        <Loading text={"Loading Subscription"} />
      ) : (
        <>
          <h1>Choose Your Adventure...</h1>
          <div>
            {apiResponse.checkoutError && (
              <Alert text={apiResponse.checkoutError} type="error" />
            )}
          </div>

          {choiceOfSubscriptions
            .filter((s) => s.metadata.perks != null)
            .map((subscriptions, idx) => {
              return (
                <SubscriptionItem
                  key={idx}
                  name={subscriptions.name}
                  price={subscriptions.price}
                  priceLookupKey={subscriptions.priceLookupId}
                  perks={subscriptions.metadata.perks}
                />
              );
            })}
          <h6 className="font-weight-normal">* Terms and Conditions apply</h6>
        </>
      )}
      <h4 className="paddingtop20">SECURE | RESPONSIVE | SIMPLE</h4>
      <div className="paddingtop20"></div>
    </div>
  );
}
